import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { auth } from './auth.module';
import { releaseInfo } from './release-info.module';
import { users } from './users.module';
import Wallet from './wallet.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alert,
    auth,
    releaseInfo,
    users,
    wallet: Wallet
  }
});
